import axios from "axios";
import Globais, { validateToken } from "../components/Globais";
import { Caracteristicas } from "../interfaces/Caracteristicas";

export type CaracteristicaPayload = Pick<Caracteristicas, "nome" | "escopo">;

export const cadastrarCaracteristicaService = async (
  data: CaracteristicaPayload
) => {
  const Token = validateToken();

  if (!Token) return false;

  try {
    const response = await axios.post(
      `${Globais.DOMINIOBACK}/caracteristicas`,
      {
        nome: data.nome,
        escopo: data.escopo || "AMBOS",
        active: 1,
      },
      {
        headers: { Authorization: Token.AuthStr },
      }
    );

    return response?.data || true;
  } catch (error) {
    console.error(error);
    return false;
  }
};
